<template>
    <ds-inline-alert class="max-recipients-alert" type="warning" leading-icon>
        <div class="max-recipients-alert-message">
            <span>
                Because you've <b>{{ boldMessage }}</b> some contacts won't receive this message. Consider removing some and sending an additional broadcast.
            </span>
        </div>
    </ds-inline-alert>
</template>
<script>
import { MAX_RECIPIENTS } from '@/components/broadcast/constants/smsBroadcast.constants';

export default {
    MAX_RECIPIENTS,

    computed: {
        boldMessage() {
            return `exceeded the allowed ${MAX_RECIPIENTS} recipients`;
        },
    },
};
</script>

<style lang="scss" scoped>
.max-recipients-alert {
    margin-bottom: $spacing-200;
}

.max-recipients-alert-message {
    line-height: $line-height-lg;
    font-size: $font-size-md;
}
</style>
